import React, { useState, useEffect } from 'react'

const AdminGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [images, setImages] = useState([]);
  const [fullScreen, setFullScreen] = useState(false);
  const [fullScreenImageUrl, setFullScreenImageUrl] = useState('');

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch('https://apis.anvifoundation.com/anvi/get-images');
        if (response.ok) {
          const data = await response.json();
          setImages(data.images);  // Set images array to state
        } else {
          alert('Failed to fetch images.');
        }
      } catch (error) {
        console.error('Error fetching images:', error);
        alert('Error fetching images.');
      }
    };

    fetchImages();
  }, []);  // Empty dependency array means this runs only once when the component mounts

  // Handle file selection
  const handleImageSelect = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  // Handle image upload
  const handleUploadImg = async (event) => {
    event.preventDefault(); // Prevent form submission
    if (!selectedImage) {
      alert("Please select an image to upload.");
      return;
    }

    // Create FormData object to send image in request
    const formData = new FormData();
    formData.append("image", selectedImage);

    try {
      // Send the image to the backend (change the URL to your backend API endpoint)
      const response = await fetch('https://apis.anvifoundation.com/anvi/upload-img', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        alert("Image uploaded successfully!");
        window.location.reload();
      } else {
        alert("Failed to upload image.");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Error uploading image.");
    }
  };


  // Handle image deletion
  const handleDeleteImg = async (imageUrl) => {
    const relativePath = imageUrl.replace("https://apis.anvifoundation.com/anvi", "");

    try {
      const response = await fetch('https://apis.anvifoundation.com/anvi/delete-img', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ imageUrl: relativePath }),
      });

      if (response.ok) {
        alert("Image deleted successfully!");
        window.location.reload();
        // Optionally, remove the image from the UI
      } else {
        const errorMessage = await response.text();
        alert(`Failed to delete image: ${errorMessage}`);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      alert("Error deleting image.");
    }
  };


  const handleOpenFullScreen = (imageUrl) => {
    setFullScreenImageUrl(imageUrl); // Set the image URL for full-screen view
    setFullScreen(true); // Open full-screen view
  };

  // Handle closing full screen view
  const handleCloseFullScreen = () => {
    setFullScreen(false); // Close full-screen view
    setFullScreenImageUrl(''); // Clear the image URL
  };


  return (
    <>
      {/* admin gallery section */}
      <section className='my-5'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-8 col-12 my-2'>
              <p className='sec-heading'>Admin Gallery</p>
              <hr className='sec-heading-hr my-auto' />

              <div className='row mt-4'>
                {images.length > 0 ? (
                  images.map((imageUrl, index) => (
                    <div key={index} className="col-lg-3 col-6 my-2">
                      <div className='image-area'>
                        <img
                          src={imageUrl}
                          alt={`uploaded-image-${index}`}
                          className="img-fluid"
                        />
                        <div className='image-area-inner' onClick={() => handleOpenFullScreen(imageUrl)}>
                        <i className="fa-solid fa-up-right-and-down-left-from-center"></i>
                        </div>
                      </div>
                      <button className='delete-btn' onClick={() => handleDeleteImg(imageUrl)}><i className="fa-solid fa-trash-can"></i></button>

                    </div>
                  ))
                ) : (
                  <p>No images available.</p>
                )}
              </div>
              {/* inner row ends */}
            </div>


            <div className='col-lg-4 col-12 my-2'>
              <div className='bg-light px-4 py-4'>
                <p className='sec-heading5'>Upload New Image</p>
                <hr />

                <form class="row g-3 my-4" onSubmit={handleUploadImg}>

                  <div className='col-12'>
                    <input className='form-text bg-white' type="file" onChange={handleImageSelect} />
                  </div>

                  <div className='col-12'>
                    <button className='donate-btn mt-3'>Upload Now</button>
                  </div>

                </form>
                {/* form ends */}

              </div>
            </div>


          </div>
          {/* row ends */}


        </div>
      </section>
      {/* admin gallery section ends */}

      {fullScreen && (
        <section className='fullscreen-area'>
          <div className="container">
          <button className="imgClose-btn float-end" onClick={handleCloseFullScreen}><i className="fa-solid fa-xmark"></i></button>
            <img src={fullScreenImageUrl} alt="Full Screen" className="img-fluid" />
          </div>
        </section>
      )}

    </>
  )
}

export default AdminGallery
